/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import Chart from 'react-google-charts';
import { useAppSelector } from '../../../../../reducers';
import NumberFormat from '../../../../../utils/number-format';
import { getLatestReportData } from '../../utils/selectors';
import { CHART_DEFAULTS, COLOUR2, COLOUR3 } from '../../utils/constants';
import { getDataAsNumberTableAverage } from '../../utils/helpers';
import { DataOrNotWrapper } from '../DataOrNotWrapper';

const WIDTH = 280;
const HEIGHT = 120;

const EmployeeCompensation = React.memo(() => {
  const latestHistorical = useAppSelector(getLatestReportData);

  const utrCode = 'gri/2020/102-38';
  const tableColumn = 'denominator_value';

  const highestPay = getDataAsNumberTableAverage(latestHistorical?.reportData, utrCode, tableColumn);
  const averagePay = getDataAsNumberTableAverage(latestHistorical?.reportData, utrCode, 'numerator_value');
  const payRatio = highestPay ? averagePay / highestPay : 0;

  const chartData = [
    ['Gender', 'Employees', { role: 'annotation' }, { role: 'style' }],
    ['Highest paid', highestPay, 'Highest paid', COLOUR3],
    ['Employee median', averagePay, 'Employee median', COLOUR2],
  ];

  return (
    <DataOrNotWrapper
      utrCodes={[
        utrCode
      ]}
      width={WIDTH}
      height={HEIGHT}
      showNoData={!payRatio}
    >
      <div className='d-flex flex-column'>
        <div className='key-number-unit'>
          Highest paid earns <span className='text-ThemeAccentExtradark'>
            <NumberFormat value={1 / payRatio} decimalPlaces={2} /> times</span> more than Employees
        </div>
        <Chart
          chartType='BarChart'
          data={chartData}
          width={WIDTH}
          height={HEIGHT}
          options={{
            ...CHART_DEFAULTS.OPTIONS,
            bar: {
              groupWidth: '100%',
              width: '100%'
            },
            legend: {
              position: 'none'
            },
            chartArea: {
              top: 20,
              bottom: 40,
              left: 0,
              right: 0,
            },
            hAxis: {
              gridlines: {
                color: 'transparent'
              },
              textPosition: 'none',
            },
          }}
        />
      </div>
    </DataOrNotWrapper>
  );
})

export default EmployeeCompensation;
